import type { RootState } from "@lib/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  payload: {
    noOfBathrooms: [],
    noOfBedrooms: [],
    noOfParking: [],
    noOfGarages: [],
    areaMin: undefined,
    areaMax: undefined,
    priceMin: undefined,
    priceMax: undefined,
    communityIds: [],
    propertyTypeIds: [],
    amenityIds: [],
    tagIds: [],
    areaIds: [],
    handoverStatus: "",
    handoverDate:"",
    buildingIds: [],
    orderBy: "newestFirst",
  },
  location: "",
  propertyDetailsPayload: {},
};

export const buyFilterPayloadSlice = createSlice({
  name: "buyFilterPayload",
  initialState,
  reducers: {
    setBuyFilterPayload: (state, action: PayloadAction<any>) => {
      state.payload = action.payload;
    },
    setPropertyDetailsPayload: (state, action: PayloadAction<any>) => {
      state.propertyDetailsPayload = action.payload;
    },
    setLocationInput: (state, action: PayloadAction<string>) => {
      state.location = state.location
        ? `${state.location}, ${action.payload}`
        : action.payload;
    },
    resetLocationInput: (state) => {
      state.location = "";
    },
    removeLocationInput: (state, action: PayloadAction<string>) => {
      const locationArray = state.location
        ?.split(", ")
        ?.filter((loc: any) => loc !== action.payload);
      state.location = locationArray?.join?.(", ");
    },
    resetFilter: (state) => {
      state.payload = {
        noOfBathrooms: [],
        noOfBedrooms: [],
        noOfParking: [],
        noOfGarages: [],
        areaMin: undefined,
        areaMax: undefined,
        priceMin: undefined,
        priceMax: undefined,
        communityIds: [],
        propertyTypeIds: [],
        amenityIds: [],
        tagIds: [],
        buildingIds: [],
        handoverStatus: "",
        handoverDate:"",
        areaIds: [],
        orderBy: "newestFirst",
      };
    },
  },
});

export const {
  setBuyFilterPayload,
  setLocationInput,
  resetLocationInput,
  removeLocationInput,
  resetFilter,
  setPropertyDetailsPayload,
} = buyFilterPayloadSlice.actions;

export const getBuyFilterPayload = (state: RootState) =>
  state.buyFilterPayload.payload;

export const getLocationInput = (state: RootState) =>
  state.buyFilterPayload.location;

export const getPropertyDetailsPayload = (state: RootState) =>
  state.buyFilterPayload.propertyDetailsPayload;

export default buyFilterPayloadSlice.reducer;
